/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy } from 'react';

export const RailFlyoutSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  const RailFlyout = lazy(() => import('@gcc/pip-components/dist/RightRailFlyout/RightRailFlyout'));

  return (
    <Suspense fallback={<div />}>
      <RailFlyout {...props} />
    </Suspense>
  );
};
